// JsFromRoutes CacheKey e1f8883e4f713209c01c6b704080fb3f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:account_id/inbox(/:inbox_id)'),
}
